import React, { useContext } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import OutlinedInput from "@mui/material/OutlinedInput";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";

import ScienceTwoToneIcon from "@mui/icons-material/ScienceTwoTone";

import SettingsContext from "./settingsContext";
import { useTranslation } from "react-i18next";
import useClasses from "../useClasses";
import { Divider } from "@mui/material";

const styles = (theme) => ({
  paper: {
    marginTop: theme.spacing(3),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  text: {
    textAlign: "left",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  formControl: {
    width: "100%",
  },
});

export default function Dashboard({ maxWidth }) {
  const classes = useClasses(styles);
  const { t } = useTranslation();
  const { settings, handleChange } = useContext(SettingsContext);
  
  return (
    <div>
      <Container component="main" maxWidth={maxWidth}>
        <CssBaseline />
        <div className={classes.paper}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
              <FormControl className={classes.formControl} variant="outlined">
                <RadioGroup
                  name="dashboard"
                  value={settings?.dashboard ?? ""}
                  input={
                    <OutlinedInput
                      notched
                      label={t("account.dashboard.defaultDashboard")}
                    />
                  }
                  onChange={handleChange}
                  label={t("account.dashboard.defaultDashboard")}
                >
                  <Typography variant="h6" sx={{ paddingBottom: 1 }}>
                    {t("account.dashboard.defaultDashboard")}
                  </Typography>
                  <FormControlLabel
                    value={"dash-stable"}
                    control={<Radio />}
                    label={t("account.dashboard.forPractitioners")}
                  />
                  <FormControlLabel
                    value={"dashboard-stable"}
                    control={<Radio />}
                    label={t("account.dashboard.forResearchers")}
                  />
                  <FormControlLabel
                    value={""}
                    control={<Radio />}
                    label={t("account.dashboard.empty")}
                  />
                  <Box paddingTop={2} paddingBottom={2}>
                    <Divider />
                    <Box padding={0.5} />
                    <Typography variant="subtitle1" fontWeight={500}>
                      {t("account.dashboard.joinBeta")}
                    </Typography>
                    <Box display="flex" gap={2}>
                      <Typography variant="body2">
                        {t("account.dashboard.betaDescription")}
                      </Typography>
                      <Box>
                        <ScienceTwoToneIcon
                          fontSize="large"
                          sx={{ rotate: "25deg", color: "primary.main" }}
                        />
                      </Box>
                    </Box>
                    <Box paddingBottom={1} />
                    <FormControlLabel
                      value={"dash-beta"}
                      control={<Radio />}
                      label={t("account.dashboard.betaForPractitioners")}
                    />
                    <FormControlLabel
                      value={"dashboard-beta"}
                      control={<Radio />}
                      label={t("account.dashboard.betaForResearchers")}
                    />
                    <Box padding={0.5} />
                    <Divider />
                  </Box>
                </RadioGroup>
              </FormControl>
            </Grid>
          </Grid>
          {/*  <Grid item xs={12} style={{marginRight: "auto"}}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={joinPreviewProgramChecked}
                  //onChange={handleChange}
                  //name={"findOnName"}
                  color="primary"
                  disabled={settings.dashboard === ""}
                />
              }
              label={t("account.dashboard.joinPreviewProgram")}
            />
          </Grid> */}
        </div>
      </Container>
    </div>
  );
}
